const HOSTNAME = window.location.hostname

type Environment = "production" | "staging" | "development"

function getEnvironment(): Environment {
  if (HOSTNAME === "app.intuidesk.com") return "production"
  if (HOSTNAME === "manage.intuidesk.com") return "production"
  if (HOSTNAME === "dashboard.intuidesk.com") return "production"
  if (HOSTNAME === "management.intuidesk.com") return "production"
  if (HOSTNAME === "staging.app.intuidesk.com") return "staging"
  if (HOSTNAME === "staging.manage.intuidesk.com") return "staging"
  if (HOSTNAME === "staging.dashboard.intuidesk.com") return "staging"
  if (HOSTNAME === "staging.management.intuidesk.com") return "staging"
  return "development"
}

const config = {
  production: {
    SYSTEM_API_KEY: "architeck-1957163548",
    API_URL: "https://api.intuidesk.com",
    PROCESSING_URL: "https://processing.intuidesk.com",
    SOCKET_URL: "https://sockets.intuidesk.com",
    AUTH_URL: "https://auth.intuidesk.com",
    APP_URL: "https://app.intuidesk.com",
  },
  staging: {
    SYSTEM_API_KEY: "architeck-4184167461",
    API_URL: "https://staging.api.intuidesk.com",
    PROCESSING_URL: "https://staging.processing.intuidesk.com",
    SOCKET_URL: "https://staging.sockets.intuidesk.com",
    AUTH_URL: "https://staging.auth.intuidesk.com",
    APP_URL: "https://staging.app.intuidesk.com",
  },
  development: {
    SYSTEM_API_KEY: "architeck-",
    API_URL: "http://localhost:5001",
    PROCESSING_URL: "http://localhost:5002",
    SOCKET_URL: "http://localhost:5003",
    AUTH_URL: "http://localhost:3001",
    APP_URL: "http://localhost:3002",
  },
}

export const keys = config[getEnvironment()]
export const environment = getEnvironment()
